import { getCurrentSubdomain, navigateTo } from "@/common/functions";
import { subdomains, root } from "@/common/consts";
import WordService from "@/services/WordService";

export default {
    data() {
        return {
            current: null,
            tabs: [
                {
                    label: "itemDefinitions",
                    subdomain: subdomains.DEFINITIONS,
                    href: `${root.WWW}${this.$route.path}`
                },
                {
                    label: "itemSynonyms",
                    subdomain: subdomains.THESAURUS,
                    href: `${root.THESAURUS}${this.$route.path}`
                },
                {
                    label: "itemSentences",
                    subdomain: subdomains.SENTENCES,
                    href: `${root.SENTENCES}${this.$route.path}`
                },
                {
                    label: "itemQuotes",
                    subdomain: subdomains.QUOTES,
                    href: `${root.QUOTES}${this.$route.path}`
                },
                {
                    label: "itemSpanish",
                    subdomain: subdomains.SPANISH,
                    href: `${root.SPANISH}${this.$route.path}`
                }
            ],
            scrollEdge: {
                left: true,
                right: false
            }
        };
    },
    methods: {
        switchTab(tab) {
            if (this.current.subdomains !== tab.subdomain) {
                this.current = tab;
                navigateTo(tab.subdomain, this.$route.path);
            }
        },
        isCurrent(tab) {
            return this.current === tab;
        },
        onScroll(event) {
            let el = event.target;
            this.scrollEdge.left = el.scrollLeft === 0;
            this.scrollEdge.right = el.scrollLeft === el.scrollWidth - el.clientWidth;
        }
    },
    created() {
        const subdomain = getCurrentSubdomain();
        const currentTab = this.tabs.find(tab => tab.subdomain === subdomain) || null;
        this.current = currentTab;

        WordService.getSections(this.$route.params.slug).then(
            res => {
                if (res.data.status && res.data.status === "ok") {
                    this.tabs = this.tabs.filter(t => {
                        return res.data.data.includes(this.$t(t.label));
                    });
                }
            },
            err => {
                // eslint-disable-next-line no-console
                console.error(err);
            }
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/ResultTabs/ResultTabs.js